import {ClipboardEvent, KeyboardEvent, useEffect, useRef} from "react";

import {RESERVATION_CODE_LENGTH} from "../constants/reservation_constants";
import {dropKeptDigit, getCodeKeyDownChange, getDigitsOnly, insertCodeDigits} from "../utils/reservation_code_digits";

interface IUseReservationCodeInputsParams {
    digits: string[];
    disabled: boolean;
    // bumped whenever the first input should take focus
    focusRequestId: number;
    onChange: (digits: string[]) => void;
    // called once per change that leaves every input filled
    onComplete: (code: string) => void;
}

const useCodeInputsFocus = (focusRequestId: number, disabled: boolean) => {
    const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
    const handledFocusRequestIdRef = useRef<number | null>(null);

    useEffect(() => {
        // a request made while the inputs are disabled (e.g. during a confirm) waits until they are enabled again
        if (disabled || handledFocusRequestIdRef.current === focusRequestId) {
            return;
        }

        handledFocusRequestIdRef.current = focusRequestId;
        inputRefs.current[0]?.focus({preventScroll: true});
    }, [focusRequestId, disabled]);

    const focusInput = (index: number) => {
        inputRefs.current[Math.min(index, RESERVATION_CODE_LENGTH - 1)]?.focus();
    };

    const setInputRef = (index: number) => (element: HTMLInputElement | null) => {
        inputRefs.current[index] = element;
    };

    return {setInputRef, focusInput};
};

// The digits of the code split over one input per digit - typing, pasting and the autofilled code move the focus along
export const useReservationCodeInputs = (params: IUseReservationCodeInputsParams) => {
    const {digits, disabled, focusRequestId, onChange, onComplete} = params;
    const {setInputRef, focusInput} = useCodeInputsFocus(focusRequestId, disabled);
    const currentDigits = Array.from({length: RESERVATION_CODE_LENGTH}, (_, index) => digits[index] ?? "");

    const insertDigits = (index: number, typedDigits: string) => {
        const {nextDigits, focusIndex} = insertCodeDigits(currentDigits, index, typedDigits);
        focusInput(focusIndex);

        if (nextDigits.every((digit, digitIndex) => digit === currentDigits[digitIndex])) {
            return;
        }

        onChange(nextDigits);

        if (nextDigits.every((digit) => digit !== "")) {
            onComplete(nextDigits.join(""));
        }
    };

    const handleChange = (index: number, value: string) => {
        if (value === "") {
            onChange(currentDigits.map((digit, digitIndex) => (digitIndex === index ? "" : digit)));
            return;
        }

        const typedDigits = dropKeptDigit(getDigitsOnly(value), currentDigits[index]);

        if (typedDigits !== "") {
            insertDigits(index, typedDigits);
        }
    };

    const handleKeyDown = (index: number, event: KeyboardEvent<HTMLInputElement>) => {
        const change = getCodeKeyDownChange(event.key, index, currentDigits);

        if (change !== null) {
            event.preventDefault();

            if (change.nextDigits) {
                onChange(change.nextDigits);
            }

            focusInput(change.focusIndex);
        }
    };

    const handlePaste = (index: number, event: ClipboardEvent<HTMLInputElement>) => {
        const pastedDigits = getDigitsOnly(event.clipboardData.getData("text"));

        if (pastedDigits !== "") {
            event.preventDefault();
            insertDigits(index, pastedDigits);
        }
    };

    return {currentDigits, setInputRef, handleChange, handleKeyDown, handlePaste};
};
import {ClipboardEvent, KeyboardEvent, useEffect, useRef} from "react";

import {RESERVATION_CODE_LENGTH} from "../constants/reservation_constants";
import {dropKeptDigit, getCodeKeyDownChange, getDigitsOnly, insertCodeDigits} from "../utils/reservation_code_digits";

interface IUseReservationCodeInputsParams {
    digits: string[];
    disabled: boolean;
    // bumped whenever the first input should take focus
    focusRequestId: number;
    onChange: (digits: string[]) => void;
    // called once per change that leaves every input filled
    onComplete: (code: string) => void;
}

const useCodeInputsFocus = (focusRequestId: number, disabled: boolean) => {
    const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
    const handledFocusRequestIdRef = useRef<number | null>(null);

    useEffect(() => {
        // a request made while the inputs are disabled (e.g. during a confirm) waits until they are enabled again
        if (disabled || handledFocusRequestIdRef.current === focusRequestId) {
            return;
        }

        handledFocusRequestIdRef.current = focusRequestId;
        inputRefs.current[0]?.focus({preventScroll: true});
    }, [focusRequestId, disabled]);

    const focusInput = (index: number) => {
        inputRefs.current[Math.min(index, RESERVATION_CODE_LENGTH - 1)]?.focus();
    };

    const setInputRef = (index: number) => (element: HTMLInputElement | null) => {
        inputRefs.current[index] = element;
    };

    return {setInputRef, focusInput};
};

// The digits of the code split over one input per digit - typing, pasting and the autofilled code move the focus along
export const useReservationCodeInputs = (params: IUseReservationCodeInputsParams) => {
    const {digits, disabled, focusRequestId, onChange, onComplete} = params;
    const {setInputRef, focusInput} = useCodeInputsFocus(focusRequestId, disabled);
    const currentDigits = Array.from({length: RESERVATION_CODE_LENGTH}, (_, index) => digits[index] ?? "");

    const insertDigits = (index: number, typedDigits: string) => {
        const {nextDigits, focusIndex} = insertCodeDigits(currentDigits, index, typedDigits);
        focusInput(focusIndex);

        if (nextDigits.every((digit, digitIndex) => digit === currentDigits[digitIndex])) {
            return;
        }

        onChange(nextDigits);

        if (nextDigits.every((digit) => digit !== "")) {
            onComplete(nextDigits.join(""));
        }
    };

    const handleChange = (index: number, value: string) => {
        if (value === "") {
            onChange(currentDigits.map((digit, digitIndex) => (digitIndex === index ? "" : digit)));
            return;
        }

        const typedDigits = dropKeptDigit(getDigitsOnly(value), currentDigits[index]);

        if (typedDigits !== "") {
            insertDigits(index, typedDigits);
        }
    };

    const handleKeyDown = (index: number, event: KeyboardEvent<HTMLInputElement>) => {
        const change = getCodeKeyDownChange(event.key, index, currentDigits);

        if (change !== null) {
            event.preventDefault();

            if (change.nextDigits) {
                onChange(change.nextDigits);
            }

            focusInput(change.focusIndex);
        }
    };

    const handlePaste = (index: number, event: ClipboardEvent<HTMLInputElement>) => {
        const pastedDigits = getDigitsOnly(event.clipboardData.getData("text"));

        if (pastedDigits !== "") {
            event.preventDefault();
            insertDigits(index, pastedDigits);
        }
    };

    return {currentDigits, setInputRef, handleChange, handleKeyDown, handlePaste};
};
